module.exports = __webpack_public_path__ + "media/images/front/icon_pen-9da0a175d16f0bdf5151c750a278601a.png";